// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-dropdown__container[data-v-e91d5588]{position:relative}.v-dropdown__body[data-v-e91d5588]{background:#fff;box-shadow:0 4px 35px rgba(9,63,90,.11);border-radius:16px}.v-dropdown__content[data-v-e91d5588]{padding-top:20px;position:absolute;top:100%;left:0;min-width:100%;z-index:99}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
